import { get, set } from '../local-storage';
import { getStore } from '../store';
import {
  updateSelectedBaseMapLayer,
  initialSettingsState,
} from '../store/modules/app-controls';
import terrain from './layers/terrain';
import satellite from './layers/satellite';
import light from './layers/light';
import night from './layers/night';
import nautical from './layers/nautical';
import treasure from './layers/treasure';

export const updateBaseLayer = (selectedBaseMapLayer) => {
  set('mapStyleService', 'selectedBaseMapLayer', selectedBaseMapLayer);
  getStore().dispatch(updateSelectedBaseMapLayer(selectedBaseMapLayer));
};

export const mapBaseLayerDefinitions = {
  satellite,
  terrain,
  nautical,
  light,
  night,
  treasure,
};

export const initialize = async () => {
  const localSetting = await get('mapStyleService', 'selectedBaseMapLayer');
  const selectedBaseMapLayer =
    localSetting || initialSettingsState.selectedBaseMapLayer;

  // Update!
  updateBaseLayer(selectedBaseMapLayer);
};
